import { LoginForm } from "@/components/login-form"
import { BotMessageSquare } from "lucide-react"
import { Toaster } from "@/components/ui/sonner"
import { getMetaValue } from "@/utils/meta.utils"
import { ThemeProvider } from "@/providers/theme-provider"

export const App = () => {
  return (
    <ThemeProvider defaultTheme="system" storageKey="landing-ui-theme">
      <Toaster position="top-center" richColors />
      <div className="grid min-h-svh lg:grid-cols-2">
        <div className="flex flex-col gap-4 p-6 md:p-10">
          <div className="flex justify-center gap-2 md:justify-start">
            <a href="#" className="flex items-center gap-2 font-medium">
              <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
                <BotMessageSquare className="size-4" />
              </div>
              {`${getMetaValue("organization-name")} chatbot`}
            </a>
          </div>
          <div className="flex flex-1 items-center justify-center">
            <div className="w-full max-w-xs">
              <LoginForm />
            </div>
          </div>
        </div>
        <div className="bg-muted relative hidden lg:block">
          <img
            src="/3d-abstract-background-with-colourful-low-poly-plexus-design.avif"
            alt="Image"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </ThemeProvider>
  )
}
